import React, { useEffect } from 'react'
import SignIn from '../components/Signin'
import ScrollToTop from '../components/ScrollToTop';
import SettingsPhoneIcon from '@mui/icons-material/SettingsPhone';
import TuneIcon from '@mui/icons-material/Tune';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { USER_MENU_STATE_CHANGE } from '../redux/constanst/index';
import { useDispatch } from 'react-redux';

import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import CreditScoreIcon from '@mui/icons-material/CreditScore';

const SigninPage = (props) => {
    const dispatch = useDispatch();


    const [menuOpt] = React.useState([
        {
            title: 'Tablero',
            icon: <LeaderboardIcon />
        },
        {
            title: 'Mis llamadas',
            icon: <SettingsPhoneIcon />,
            Category: [
                {
                    id: 0,
                    name: 'Entrantes',
                },
                {
                    id: 1,
                    name: 'Salientes',
                },
                {
                    id: 2,
                    name: 'Combinado',
                }/* ,
                {
                    id: 3,
                    name: 'Distribucion',
                } */
            ]
        },
        {
            title: 'Configuracion',
            icon: <TuneIcon />
        },
        {
            title: 'Detalle de Anexos',
            icon: <PermPhoneMsgIcon />
        },
        {
            title: 'Facturacion',
            icon: <CreditScoreIcon />
        },
        
    ])

    useEffect(() => {
        dispatch({ type: USER_MENU_STATE_CHANGE, menu: menuOpt })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.menu])


    return (
        <>
            <ScrollToTop />
            <SignIn />
        </>
    )
}

export default SigninPage
